import { graphql } from "@/lib/gql/__generated__/gql";

export const HOTEL_NOTIFICATION_SETTING_QUERY = graphql(/* GraphQL */ `
	query HotelNotificationSettingQuery($hotelID: ID!) {
		hotelNotificationSetting(hotelID: $hotelID) {
			ecNotificationEmails
			hotelID
			id
			paymentNotificationEmails
			reservationNotificationEmails
		}
	}
`);
